import type { CalendarEvent } from 'paintscout'

interface GetVisibleEventsArgs {
  events: CalendarEvent[]
  view: 'day' | 'week' | 'month'
  date: Date
  hideWeekends?: boolean
}

export function getVisibleCalendarEvents({
  events,
  view,
  date,
  hideWeekends = false
}: GetVisibleEventsArgs): CalendarEvent[] {
  const start = new Date(date)
  let end = new Date(date)

  if (view === 'day') {
    start.setHours(0, 0, 0, 0)
    end.setHours(23, 59, 59, 999)
  } else if (view === 'week') {
    start.setDate(start.getDate() - start.getDay())
    start.setHours(0, 0, 0, 0)
    end = new Date(start)
    end.setDate(end.getDate() + 6)
    end.setHours(23, 59, 59, 999)
  } else if (view === 'month') {
    start.setDate(1)
    start.setHours(0, 0, 0, 0)
    end = new Date(start)
    end.setMonth(end.getMonth() + 1)
    end.setDate(0)
    end.setHours(23, 59, 59, 999)
  }

  return events.filter((event) => {
    const eventStart = new Date(event.start)
    const eventEnd = event.end ? new Date(event.end) : eventStart
    const isUnavailability = event.eventType === '_unavailable_'

    // Multi-day event logic: event overlaps with visible range
    const overlaps = eventEnd >= start && eventStart < end

    if (view === 'week' && hideWeekends) {
      // If all days of the event are on weekends, hide it
      // Otherwise, show if any part overlaps a weekday
      let show = false
      const current = new Date(eventStart)
      while (current <= eventEnd) {
        const day = current.getDay()
        if (day !== 0 && day !== 6) {
          show = true
          break
        }
        current.setDate(current.getDate() + 1)
      }
      if (!show) return false
    }

    return overlaps && !isUnavailability
  })
}
